import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slider", "next", "prev", "dot"];

  connect() {
    // Check if slider target exists before proceeding
    if (!this.hasSliderTarget) {
      // Home controller connected but no slider target found
      return;
    }

    this.calculateSlideSettings();

    this.sliderTarget.addEventListener(
      "scroll",
      this.updateButtonStates.bind(this)
    );

    this.sliderTarget.addEventListener(
      "scroll",
      this.updateActiveDot.bind(this)
    );

    window.addEventListener("resize", this.calculateSlideSettings.bind(this));

    this.updateButtonStates();
    this.updateActiveDot();
  }

  disconnect() {
    // Check if slider target exists before removing event listeners
    if (!this.hasSliderTarget) {
      return;
    }

    this.sliderTarget.removeEventListener(
      "scroll",
      this.updateButtonStates.bind(this)
    );

    window.removeEventListener(
      "resize",
      this.calculateSlideSettings.bind(this)
    );
  }

  calculateSlideSettings() {
    // Safety check for slider target
    if (!this.hasSliderTarget) {
      return;
    }

    const remInPx = parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );

    const remValue = 25 * remInPx;
    const vwValue = window.innerWidth * 0.9;

    this.slideWidth = Math.min(remValue, vwValue);
    this.gap = 0.75 * remInPx;

    const totalSlideWidth = this.slideWidth + this.gap;
    const visibleWidth = this.sliderTarget.clientWidth;

    this.slidesToMove = Math.max(1, Math.floor(visibleWidth / totalSlideWidth));
  }

  // updateButtonStates() {
  //   const isAtStart = this.sliderTarget.scrollLeft <= 0;
  //   const isAtEnd =
  //     this.sliderTarget.scrollLeft >=
  //     this.sliderTarget.scrollWidth - this.sliderTarget.clientWidth;

  //   this.prevTarget.disabled = isAtStart;
  //   this.nextTarget.disabled = isAtEnd;
  // }

  updateButtonStates() {
    // Safety checks for all required targets
    if (!this.hasSliderTarget || !this.hasPrevTarget || !this.hasNextTarget) {
      return;
    }

    const isAtStart = this.sliderTarget.scrollLeft <= 0;
    const isAtEnd =
      this.sliderTarget.scrollLeft >=
      this.sliderTarget.scrollWidth - this.sliderTarget.clientWidth;

    // Überprüfen, ob überhaupt gescrollt werden kann
    const canScroll =
      this.sliderTarget.scrollWidth > this.sliderTarget.clientWidth;

    if (canScroll) {
      // Wenn gescrollt werden kann, die Buttons je nach Position aktivieren/deaktivieren
      this.prevTarget.disabled = isAtStart;
      this.nextTarget.disabled = isAtEnd;
      // Sicherstellen, dass die Buttons sichtbar sind, falls sie vorher ausgeblendet wurden
      this.prevTarget.style.display = ""; // Oder 'block', 'inline-block', je nach deinem CSS
      this.nextTarget.style.display = ""; // Oder 'block', 'inline-block'
    } else {
      // Wenn nicht gescrollt werden kann, beide Buttons ausblenden
      this.prevTarget.style.display = "none";
      this.nextTarget.style.display = "none";
    }
  }

  next() {
    // Safety check before scrolling
    if (!this.hasSliderTarget) {
      return;
    }

    const currentScroll = this.sliderTarget.scrollLeft;
    const slideWidth = this.slideWidth + this.gap;
    const newScroll = Math.round(
      currentScroll + slideWidth * this.slidesToMove
    );

    this.sliderTarget.scrollTo({
      left: newScroll,
      behavior: "smooth",
    });
  }

  prev() {
    // Safety check before scrolling
    if (!this.hasSliderTarget) {
      return;
    }

    const currentScroll = this.sliderTarget.scrollLeft;
    const slideWidth = this.slideWidth + this.gap;
    const newScroll = Math.round(
      currentScroll - slideWidth * this.slidesToMove
    );

    this.sliderTarget.scrollTo({
      left: newScroll,
      behavior: "smooth",
    });
  }

  updateActiveDot() {
    if (!this.hasSliderTarget || !this.hasDotTarget) {
      return;
    }

    const cards = this.sliderTarget.children;
    if (cards.length === 0) return;

    const scrollLeft = this.sliderTarget.scrollLeft;
    const containerWidth = this.sliderTarget.clientWidth;

    // Find which card is most centered/visible
    let activeIndex = 0;
    let minDistance = Infinity;

    Array.from(cards).forEach((card, index) => {
      const cardLeft = card.offsetLeft - this.sliderTarget.offsetLeft;
      const cardCenter = cardLeft + card.offsetWidth / 2;
      const viewCenter = scrollLeft + containerWidth / 2;
      const distance = Math.abs(cardCenter - viewCenter);

      if (distance < minDistance) {
        minDistance = distance;
        activeIndex = index;
      }
    });

    // Update dot states
    this.dotTargets.forEach((dot, index) => {
      dot.classList.toggle("subscription-slider__dot--active", index === activeIndex);
    });
  }

  goToSlide(event) {
    if (!this.hasSliderTarget) {
      return;
    }

    const index = parseInt(event.currentTarget.dataset.index, 10);
    const cards = this.sliderTarget.children;

    if (index >= 0 && index < cards.length) {
      const card = cards[index];
      const scrollLeft = card.offsetLeft - this.sliderTarget.offsetLeft;

      // On mobile, center the card
      const containerWidth = this.sliderTarget.clientWidth;
      const cardWidth = card.offsetWidth;
      const centeredScroll = scrollLeft - (containerWidth - cardWidth) / 2;

      this.sliderTarget.scrollTo({
        left: Math.max(0, centeredScroll),
        behavior: "smooth",
      });
    }
  }
}
